// Italian (`it`) shell baseline
import { layoutIt } from './it/layout'
import { homeIt } from './it/home'
import { playIt } from './it/play'
import { demoIt } from './it/demo'
import { booksIt } from './it/books'
import { commerceIt } from './it/commerce'
import { communityIt } from './it/community'
import { dashboardIt } from './it/dashboard'
import { authIt } from './it/auth'
import { marketingIt } from './it/marketing'
import { worldIt } from './it/world'
import { encyclopediaIt } from './it/encyclopedia'
import { systemIt } from './it/system'
import { cityIt } from './it/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseIt: MessageCatalog = {
  ...layoutIt,
  ...homeIt,
  ...playIt,
  ...demoIt,
  ...booksIt,
  ...commerceIt,
  ...communityIt,
  ...dashboardIt,
  ...authIt,
  ...marketingIt,
  ...worldIt,
  ...encyclopediaIt,
  ...systemIt,
  ...cityIt,
}
